module.exports = __webpack_public_path__ + "img/program2.0366bbe8.svg";